import { ApiCallStorageReaderInterface } from "./ApiCallStorageReaderInterface";
class ApiCallStorageReader extends ApiCallStorageReaderInterface {
  constructor(apiCallStorage, apiClient, sharedStorage, apiErrorInterpreter) {
    super();
    this.apiCallStorage = apiCallStorage;
    this.apiClient = apiClient;
    this.sharedStorage = sharedStorage;
    this.apiErrorInterpreter = apiErrorInterpreter;
  }
  register = (name, method, path, isExpiredFunc, updateIsExpiredFuncTracking, defaultValue, formatResultFunc) => {
    this.apiCallStorage.register(name, this._generateApiCallStorageValue(defaultValue, defaultValue, isExpiredFunc, updateIsExpiredFuncTracking, formatResultFunc));
    this.apiClient.registerEndpoint(name, method, path);
    return this;
  };
  read = async (name, queryParam = {}) => {
    this._enforceNameRegistered(name);
    const {
      value,
      isExpiredFunc,
      updateIsExpiredFuncTracking,
      defaultValue,
      formatResultFunc
    } = this.apiCallStorage.get(name);
    let result = value;

    // if the stored result is expired
    // then remove that result and get a new one    
    const isExpired = await isExpiredFunc(this.sharedStorage);
    if (isExpired === true || value === defaultValue) {
      this.apiCallStorage.set(name, this._generateApiCallStorageValue(defaultValue, defaultValue, isExpiredFunc, updateIsExpiredFuncTracking, formatResultFunc));
      result = await this.refresh(name, queryParam);
    }
    return result;
  };
  refresh = async (name, queryParam = {}) => {
    this._enforceNameRegistered(name);
    const {
      defaultValue,
      isExpiredFunc,
      updateIsExpiredFuncTracking,
      formatResultFunc
    } = this.apiCallStorage.get(name);
    let result = await formatResultFunc(await this.apiClient[name](queryParam));
    let newStoredValue = result;

    // dont store an error response, so that the read method will try to get a new result
    if (this.apiErrorInterpreter.isError(result)) {
      newStoredValue = defaultValue;
    }
    this.apiCallStorage.set(name, this._generateApiCallStorageValue(defaultValue, newStoredValue, isExpiredFunc, updateIsExpiredFuncTracking, formatResultFunc));

    // run updateIsExpiredFuncTracking in order to update the isExpired tracking variables now that the new result promise is resolved    
    updateIsExpiredFuncTracking(this.sharedStorage);
    return result;
  };
  _generateApiCallStorageValue = (defaultValue, value, isExpiredFunc, updateIsExpiredFuncTracking, formatResultFunc) => {
    return {
      defaultValue,
      value,
      isExpiredFunc,
      updateIsExpiredFuncTracking,
      formatResultFunc
    };
  };

  // if the name is not registered
  // then throw an error
  _enforceNameRegistered = name => {
    const storageVal = this.apiCallStorage.get(name);
    const clientVal = this.apiClient[name];
    if (typeof storageVal === "undefined" || typeof clientVal === "undefined") {
      throw new Error("UNREGISTERED_NAME");
    }
    return this;
  };
}
export { ApiCallStorageReader };